// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bqclp{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-phzym{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bustn{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bwrhe{grid-column:span 3}.assets-scss-gridstyleGrid-col4-epufi{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bygfh{grid-column:span 9}.assets-scss-gridstyleGrid-col12-blwnp{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-dprpd{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bqclp",
	"grid": "assets-scss-gridstyleGrid-grid-phzym",
	"col6": "assets-scss-gridstyleGrid-col6-bustn",
	"col3": "assets-scss-gridstyleGrid-col3-bwrhe",
	"col4": "assets-scss-gridstyleGrid-col4-epufi",
	"col9": "assets-scss-gridstyleGrid-col9-bygfh",
	"col12": "assets-scss-gridstyleGrid-col12-blwnp",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-dprpd"
};
module.exports = ___CSS_LOADER_EXPORT___;
